import { HouseholdChatMessage } from '@/modules/household/chat/contexts/householdChat.context';
import {
  HouseholdRespondToChatMessageInput,
  MessageResponseAction,
} from '@/types/schema';

export function getValidationQuestions(message?: HouseholdChatMessage) {
  return (
    message?.groupedQuestionContent?.questions ??
    (message?.freeFormQuestionContent
      ? [{ id: message.id, ...message.freeFormQuestionContent }]
      : [])
  );
}

export function getValidationResponse(
  message: HouseholdChatMessage,
  answers: Record<string, string>
): HouseholdRespondToChatMessageInput {
  const questionAnswers = getValidationQuestions(message).flatMap(({ id }) => {
    const answer = answers[id]?.trim();
    return answer ? [{ id, answer }] : [];
  });
  if (!questionAnswers.length) {
    return {
      messageID: message.id,
      responseAction: MessageResponseAction.Dismiss,
    };
  }
  const input = {
    messageID: message.id,
    responseAction: MessageResponseAction.Submit,
  };
  if (message.groupedQuestionContent) return { ...input, questionAnswers };
  return { ...input, freeFormText: questionAnswers[0]?.answer };
}
